import React, { Component } from "react"

class AnimatedCheckmarkButton extends Component {
  static defaultProps = {
    buttonText: "buttonText",
    onClickHandler: () => {
      alert("clicked")
    },
    isSelected: false,
  }

  state = {}

  render() {
    return (
      <button
        className={`animated-checkmark-button button button--small button--general ${
          this.props.isSelected ? "animated-checkmark-button--activated" : ""
        } ${this.props.buttonClass}`}
        onClick={this.props.onClickHandler}
      >
        <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <path strokeLinejoin="round" className="checkmark__check" strokeLinecap="round" stroke="#fff" d="M14.1 27.2l7.1 7.2 10.7-20.8" />
        </svg>
        <span className="text">{this.props.buttonText}</span>
      </button>
    )
  }
}

export default AnimatedCheckmarkButton
